<div class="content-wrapper">
  @if (!loading) {
    <div class="title-wrapper"><div class="wrapper-text-h1">Select Room to Apply Entry Flow To</div></div>
    <div class="card-container">
      <div class="input-title">Room Name</div>
      <div class="room-select">
        <mat-select
          [(ngModel)]="selectedRoomArray"
          aria-label="Select Room Name"
          placeholder="Select Room Name"
          matInput
          required
          [disabled]="hasStartingPoint"
          [matTooltip]="
            hasStartingPoint
              ? 'You cannot attach this entry flow to a room due to a pre-existing Starting Point entry flow. Please delete the Starting Point entry flow to proceed'
              : ''
          "
        >
          @for (room of rooms; track room.socialId) {
            <div
              [matTooltip]="
                roomIsTaken(room)
                  ? 'Entry Flow already attached, please remove current entry flow before adding a new one'
                  : ''
              "
              matTooltipPosition="right"
            >
              <mat-option [disabled]="roomIsTaken(room)" [value]="room.socialId">{{ room.name }}</mat-option>
            </div>
          }
        </mat-select>
      </div>
    </div>
    <div class="footer-wrapper">
      <button data-testid="primaryButton" class="primary-button" [disabled]="isDisabled" (click)="nextStep()">
        Apply
      </button>
    </div>
  } @else {
    <div class="flex justify-center w-full">
      <app-loading></app-loading>
    </div>
  }
</div>
